(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      // this.setHeaderHeight();

      // window.matchMedia('(max-width: 1024px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

// setHeaderHeight() {
// document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
// }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;
      
      let annoucementBar = document.querySelector('.announcement-bar-section')
      let announceHeight = annoucementBar ? annoucementBar.clientHeight : 0
      let windowWidth = window.innerWidth
      let headerTop =  announceHeight
      let headerTopwide =  announceHeight - 2
      let collectionTopSlider = document.querySelector('[collection-outer-slider]')
      let header = document.querySelector('.section-header')
      let headerHeight = header.clientHeight
      let collectionSliderTop = headerTopwide + headerHeight
      let staticpagetopbar = document.querySelector('[static-page-top-bar]')

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if(windowWidth < 767 && annoucementBar) {
          annoucementBar.style.position = 'sticky'
          window.__bwHomeHeaderGeometry?.markMobileSticky(annoucementBar)
        }      
        this.header.classList.add('scrolled-past-header');
        if(windowWidth > 3000){
          this.header.style.top = `${annoucementBar ? headerTopwide : 0}px`
          if (document.documentElement.classList.contains('bw-home-header-geometry')) this.header.style.setProperty('--bw-initial-header-offset', this.header.style.top);
          if(collectionTopSlider){
            collectionTopSlider.style.top = `${collectionSliderTop}px`
          }
        }else{
          this.header.style.top = `${annoucementBar ? headerTop - 1 : 0}px`
          if (document.documentElement.classList.contains('bw-home-header-geometry')) this.header.style.setProperty('--bw-initial-header-offset', this.header.style.top);
          if(collectionTopSlider){
            collectionTopSlider.style.top = `${collectionSliderTop - 1}px`
          }
        }
        if(staticpagetopbar) {
         staticpagetopbar.style.position = 'fixed'
         staticpagetopbar.style.top = `${headerHeight + announceHeight - 2}px`
         staticpagetopbar.style.paddingTop = '0'
        }
        
        if (this.preventHide) return;
        
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if(windowWidth > 3000){
          this.header.style.top = `${annoucementBar ? headerTopwide : 0}px`
          if (document.documentElement.classList.contains('bw-home-header-geometry')) this.header.style.setProperty('--bw-initial-header-offset', this.header.style.top);
          if(collectionTopSlider){
            collectionTopSlider.style.top = `${collectionSliderTop}px`
          }
        }else{
          this.header.style.top = `${annoucementBar ? headerTop - 1 : 0}px`
          if (document.documentElement.classList.contains('bw-home-header-geometry')) this.header.style.setProperty('--bw-initial-header-offset', this.header.style.top);
          if(collectionTopSlider){
            collectionTopSlider.style.top = `${collectionSliderTop - 1}px`
          } 
        }
        if(staticpagetopbar) {
         staticpagetopbar.style.position = 'fixed'
         staticpagetopbar.style.top = `${headerHeight + announceHeight - 2}px`
         staticpagetopbar.style.paddingTop = '0'
        }

        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
        if(staticpagetopbar) {
         staticpagetopbar.style.position = 'relative'
         staticpagetopbar.style.top = '0'
         staticpagetopbar.style.paddingTop = `${announceHeight - 2}px`
        }
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
